import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';

function AudioPlayer({ uniqueid, phone }) {
  const [audioUrls, setAudioUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiInstance.get('/recordings/', {
      params: {
        uniqueid: uniqueid,
        phone_number: phone,
      },
    })
    .then(response => {
      if (response.data.status === 'success') {
        setAudioUrls(response.data.urls);
      } else {
        setError(response.data.message);
      }
    })
    .catch(err => {
      setError(err.message);
    })
    .finally(() => {
      setLoading(false);
    });
  }, [uniqueid, phone]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <Box>
      {audioUrls.map((url, index) => (
        <audio key={index} controls>
          <source src={url} type="audio/mp3" />
          Your browser does not support the audio element.
        </audio>
      ))}
    </Box>
  );
}

export default AudioPlayer;
